// extracted by mini-css-extract-plugin
export default {"tos":"tos_tos__B-9of","card":"tos_card__Lud3r"};